export const TimelineData = [
    {
        id: 1,
        title: "Inline CSS with '!important' (Highest Priority)",
        desc: "Inline styles that include '!important' have the highest priority in CSS. No matter what other styles apply to the element—whether from an ID, class, or external stylesheet—'!important' ensures that the inline style takes precedence. This should only be used when absolutely necessary, as it can make styles difficult to override later.",
        example: `<div style="color: red !important;">This text will always be red</div>`
    },
    {
        id: 2,
        title: "ID Selector with '!important' (Very High Priority)",
        desc: "An ID selector is already very specific, but adding '!important' makes it even stronger. This means no regular class or inline style (without '!important') can override it. However, inline styles with '!important' will still have more priority.",
        example: `#myId { color: blue !important; }`
    },
    {
        id: 3,
        title: "Class Selector with '!important' (High Priority)",
        desc: "A class selector with '!important' has a strong priority but is still weaker than an ID with '!important'. If an element has multiple styles applied, the class with '!important' will override normal ID and class styles but not inline styles with '!important'.",
        example: `.myClass { color: green !important; }`
    },
    {
        id: 4,
        title: "Inline CSS (Higher than ID and Class, But No '!important')",
        desc: "Inline styles are applied directly to an element using the 'style' attribute. They have a higher priority than ID and class selectors, but they can still be overridden by styles with '!important'. Inline styles are useful for quick changes but should be avoided for maintainability.",
        example: `<div style="color: purple;">This text is purple because of inline CSS</div>`
    },
    {
        id: 5,
        title: "ID Selector (More Specific than Class Selector)",
        desc: "An ID selector is more specific than a class selector. If both an ID and a class are applied to an element, the ID’s styles will take precedence. However, an ID selector without '!important' can still be overridden by inline styles or other ID selectors with '!important'.",
        example: `#unique { color: orange; }`
    },
    {
        id: 6,
        title: "Class Selector (Least Specific, But Most Common)",
        desc: "A class selector is the most commonly used way to style elements. It has lower priority than inline styles and ID selectors, but it allows for reusable and organized styling. If an element has both an ID and a class, the ID’s style will override the class.",
        example: `.textStyle { color: brown; }`
    },
];
